import React from 'react';

import {
    Paper,
    ClickAwayListener,
    MenuList,
    MenuItem,
    ListItemIcon,
    Checkbox,
    ListItemText,
} from '@material-ui/core';

const BaseSelect = ({
    options = [],
    labelKey = 'title',
    valueKey = 'value',
    onClose,
    onChange,
    withCheckbox = false,
    selectAllOption = false,
    selected = [],
}) => {
    const valueToOptionMap = {};
    options.forEach(option => {
        valueToOptionMap[option[valueKey]] = option;
    });

    const allChecked = () => {
        return options.every(
            option => selected.indexOf(option[valueKey]) !== -1
        );
    };

    const handleToggle = (event, value) => {
        const currentIndex = selected.indexOf(value);
        const newChecked = [...selected];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        const newAllChecked = options.every(opt =>
            newChecked.includes(opt[valueKey])
        );
        onChange(
            event,
            newChecked.map(checked => valueToOptionMap[checked]),
            newAllChecked
        );
    };

    const handleAll = event => {
        if (allChecked()) {
            onChange(event, [], false);
        } else {
            onChange(event, options, true);
        }
    };

    return (
        <Paper style={{ maxHeight: 312, overflow: 'auto' }}>
            <ClickAwayListener onClickAway={onClose}>
                <MenuList>
                    {withCheckbox && selectAllOption && (
                        <MenuItem>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={allChecked()}
                                    onChange={handleAll}
                                    tabIndex={-1}
                                />
                            </ListItemIcon>
                            <ListItemText primary="All" />
                        </MenuItem>
                    )}
                    {options.map(option => (
                        <MenuItem
                            button
                            disableRipple
                            key={option[labelKey]}
                            onClick={
                                !withCheckbox
                                    ? event => onChange(event, option)
                                    : () => {}
                            }
                        >
                            {withCheckbox && (
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={
                                            selected.indexOf(
                                                option[valueKey]
                                            ) !== -1
                                        }
                                        onChange={event =>
                                            handleToggle(
                                                event,
                                                option[valueKey]
                                            )
                                        }
                                        tabIndex={-1}
                                    />
                                </ListItemIcon>
                            )}
                            <ListItemText primary={option[labelKey]} />
                        </MenuItem>
                    ))}
                </MenuList>
            </ClickAwayListener>
        </Paper>
    );
};

export { BaseSelect };
